import { OnInit, Component, ViewChild, ElementRef, PACKAGE_ROOT_URL } from '@angular/core';

import { OrganisationSpecificStepsService } from '../../services';
import { IOrganisationSpecificStepsGroup } from '../../interfaces/organisation-specific-steps-group';
import { compare } from 'fast-json-patch';
import { MessageService } from 'primeng';

@Component({
  selector: 'checklist-fees',
  templateUrl: './checklist-fees.component.html',
  styleUrls: ['./checklist-fees.component.scss'],
})
export class ChecklistFeesComponent implements OnInit {
  totalRecords: number;
  skip = 0;
  take = 25;

  constructor(
    private messageService: MessageService,
    private organisationSpecificStepsService: OrganisationSpecificStepsService,
  ) {}

  public checklists: IOrganisationSpecificStepsGroup[] = [];

  ngOnInit() {
    this.load();
  }

  load() {
    this.organisationSpecificStepsService.getSpecificStepsGroups().then((x) => {
      this.checklists = x.items;
      this.totalRecords = x.totalItems;
    });
  }

  onEditComplete(event: any) {
    console.log('EVENT ', event);

    let column = event.field;
    let id = event.data['id'];
    let columnValue = event.data[column];

    let patch = compare({}, { [column]: columnValue });

    this.organisationSpecificStepsService.patchSpecificStepsGroup(id, patch).then(() => {});
  }
}
